/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { Bot } from 'lucide-react';

export const LoadingMessage = () => {
    return (
        <div className="flex flex-col gap-2">
            {/* Header with icon and name - matching ChatMessageComponent structure */}
            <div className="flex items-center gap-3">
                <div className="flex-shrink-0">
                    <div className="w-8 h-8 rounded-full bg-secondary flex items-center justify-center">
                        <Bot className="h-4 w-4 text-secondary-foreground" />
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <span className="font-medium text-sm">Code Agent</span>
                </div>
            </div>

            {/* Loading content */}
            <div className="flex justify-start">
                <div className="text-sm text-foreground bg-muted/30 rounded-md p-3 inline-block">
                    <div className="flex items-center gap-2 text-muted-foreground">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary" />
                        Generating code...
                    </div>
                </div>
            </div>
        </div>
    );
};
